import React from 'react';
import { IDoorAssessment } from '../../../../entities-generated/common/door-assessment';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { IDoorTypeOption } from '../../../../entities-generated/common/door-type-option';
import { firstOrDefault } from '../../../../framework/utils/collection';

interface IProposedDoorListingProps {
  door: IDoorAssessment;
  doorTypes: IDoorTypeOption[];
  onSelect: (door: IDoorAssessment) => void;
  onRemove: (door: IDoorAssessment) => void;
}

export const ProposedDoorListing: React.FunctionComponent<IProposedDoorListingProps> = (props) => {
  const { door } = props;
  const doorType = firstOrDefault(props.doorTypes, d => d.id === door.doorType)?.description ?? 'Unknown';

  return (
    <BwjListing
      actions={[{
        icon: 'Delete',
        onClick: props.onRemove,
      }]}
      heading={door.alias}
      secondaryLine={doorType}
      data={door}
      onClick={props.onSelect}
    />
  );
};
